<template>
  <div class="mdr-body">
    <div class="mdr-container">
      <p class="mdr-paragraph">
        {{ $t("ticket.creationRequest.title", [incident.type]) }}
        {{ $t("ticket.creationRequest.body") }}
      </p>
      <button
        @click="handleApproveClick"
        :disabled="isDisabled"
        class="mdr-btn mdr-btn-primary"
      >
        {{ $t("ticket.creationRequest.yes") }}
      </button>
      <button
        @click="handleCancelClick"
        :disabled="isDisabled"
        class="mdr-btn mdr-btn-secondary"
      >
        {{ $t("ticket.creationRequest.no") }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { useStore } from "vuex";
import { computed, ref } from "vue";
import { IncidentDTO } from "@moderrotech/servers-communication-library/src/types";

export default {
  setup() {
    const store = useStore();

    const incident = computed((): IncidentDTO => store.state.incident.incident);

    const isDisabled = ref(false);

    return {
      incident,
      isDisabled,
      handleCancelClick: () => {
        isDisabled.value = true;
        store.dispatch("incident/close", {
          callback: () => (isDisabled.value = false),
          errorCallback: () => (isDisabled.value = false)
        });
      },
      handleApproveClick: () => {
        isDisabled.value = true;
        store.dispatch("incident/startProcessing", {
          callback: () => (isDisabled.value = false),
          errorCallback: () => (isDisabled.value = false)
        });
      }
    };
  }
};
</script>
<style lang="scss">
$primary-color: #1961df;
$primary-hover: scale-color($primary-color, $lightness: +20%);
$secondary-color: #6b7ea1;
$secondary-hover: scale-color($secondary-color, $lightness: +20%);
$text-color: #ffffff;

.mdr-body {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-family: Arial, sans-serif;
  background-color: #f0f0f0;
  color: #333333;
  margin: 0;
  padding: 0;
  box-sizing: border-box;

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .mdr-container {
    text-align: center;
    padding: 20px;
    //background-color: #ffffff;
    border-radius: 10px;
    //box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    max-width: 500px;
  }

  .mdr-paragraph {
    font-size: 1.2em;
    line-height: 130%;
    //text-align: left;
    margin-bottom: 30px;
  }

  .mdr-btn {
    display: block;
    width: 100%;

    margin: 10px auto;
    padding: 13px 20px;
    border: none;

    font-size: 1em;
    cursor: pointer;
    transition: background-color 0.3s;
    color: $text-color;

    max-width: 260px;
    border-radius: 4px;

    &.mdr-btn-primary {
      background-color: $primary-color;
      &:not(:disabled) {
        &:hover {
          background-color: $primary-hover;
        }
        &:active {
          background-color: scale-color($primary-color, $lightness: -10%);
        }
      }
      &:disabled {
        background-color: scale-color($secondary-color, $alpha: -80%);
        color: scale-color($secondary-color, $alpha: -60%);
      }
    }

    &.mdr-btn-secondary {
      background-color: $secondary-color;
      &:not(:disabled) {
        &:hover {
          background-color: $secondary-hover;
        }
        &:active {
          background-color: scale-color($secondary-color, $lightness: -10%);
        }
      }
      &:disabled {
        background-color: scale-color($secondary-color, $alpha: -80%);
        color: scale-color($secondary-color, $alpha: -60%);
      }
    }
  }
}
</style>
